
<div class="page-customized">
    <workout-collection
        v-if="collect"
        used
        @unused="unused"
    ></workout-collection>

    <template v-else>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <app-bar
            :title="collection.exists() ? t('collection_title_update') : t('collection_title_create')"
            back="/workout-collections"
        />

        <v-layout class="mt-n8">
            <v-card
                width="100%"
                color="transparent"
                elevation="0"
                class="pb-8"
            >
                <v-card-text class="pb-0">
                    <v-form class="mt-6">
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_name') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="collection.name"
                                    type="text"
                                    required
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('name')"
                                ></v-text-field>
                            </div>
                            <div class="horizontal-actions">
                                <edit-translations-modal
                                    v-model="collection.name"
                                    :items="collection.translations['name']"
                                    @touch="(v) => collection.translations['name'] = v"
                                ></edit-translations-modal>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_description') }}</div>
                            <div class="horizontal-input">
                                <v-textarea
                                    v-model="collection.description"
                                    required
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('description')"
                                ></v-textarea>
                            </div>
                            <div class="horizontal-actions">
                                <edit-translations-modal
                                    v-model="collection.description"
                                    :items="collection.translations['description']"
                                    @touch="(v) => collection.translations['description'] = v"
                                    text
                                ></edit-translations-modal>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_author') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="collection.author"
                                    type="text"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('author')"
                                ></v-text-field>
                            </div>
                            <div class="horizontal-actions">
                                <edit-translations-modal
                                    v-model="collection.author"
                                    :items="collection.translations['author']"
                                    @touch="(v) => collection.translations['author'] = v"
                                ></edit-translations-modal>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_video_url') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="collection.videoUrl"
                                    type="text"
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('video_url')"
                                ></v-text-field>
                            </div>
                            <div class="horizontal-actions">
                                <edit-translations-modal
                                    v-model="collection.videoUrl"
                                    :items="collection.translations['video_url']"
                                    @touch="(v) => collection.translations['video_url'] = v"
                                ></edit-translations-modal>
                            </div>
                        </div>
                        <mux-playback-id-field
                            v-model="collection.muxPlaybackId"
                            :label="t('collection_label_mux_playback_id')"
                            :errors="form.errors.get('mux_playback_id')"
                        ></mux-playback-id-field>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_photo') }}</div>
                            <div class="horizontal-input">
                                <v-file-input
                                    v-model="collection.photo"
                                    required
                                    outlined
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-paperclip"
                                    :append-outer-icon="collection.photoUrl ? 'mdi-eye-outline' : ''"
                                    dense
                                    :error-messages="photoForm.errors.get('photo')"
                                    @click:append-outer="viewPhoto()"
                                    @click:clear="collection.photo = undefined"
                                ></v-file-input>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_header_photo') }} *</div>
                            <div class="horizontal-input">
                                <v-file-input
                                    v-model="collection.headerPhoto"
                                    required
                                    outlined
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-paperclip"
                                    :append-outer-icon="collection.headerPhotoUrl ? 'mdi-eye-outline' : ''"
                                    dense
                                    :error-messages="headerPhotoError || photoForm.errors.get('header_photo')"
                                    @click:append-outer="viewHeaderPhoto()"
                                    @click:clear="collection.headerPhoto = undefined"
                                ></v-file-input>
                            </div>
                            <div class="horizontal-actions field-note">{{ t('collection_hint_header_photo') }}</div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_author_photo') }}</div>
                            <div class="horizontal-input">
                                <v-file-input
                                    v-model="collection.authorPhoto"
                                    outlined
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-paperclip"
                                    dense
                                    :error-messages="photoForm.errors.get('author_photo') || form.errors.get('author_photo_url')"
                                    @click:clear="collection.authorPhoto = undefined"
                                ></v-file-input>
                            </div>
                            <div class="horizontal-actions field-note">{{ t('collection_hint_author_photo') }}</div>
                        </div>
                        <div class="form-group-horizontal" v-if="collection.authorPhotoUrl">
                            <div class="horizontal-label"></div>
                            <div class="horizontal-input">
                                <div class="d-inline-block position-relative">
                                    <v-avatar size="92">
                                        <v-img :src="collection.authorPhotoUrl" :lazy-src="collection.authorPhotoUrl"></v-img>
                                    </v-avatar>
                                    <confirm-modal
                                        :title="t('general_title_confirm_action')"
                                        @agree="collection.delAuthorPhoto()"
                                    >
                                        <template #default="{ on, attrs }">
                                            <v-btn
                                                v-on="on"
                                                v-bind="attrs"
                                                :title="t('collection_action_remove_author_photo')"
                                                plain
                                                icon
                                                absolute
                                                top
                                                right
                                                class="mt-n3 mr-n3"
                                            ><v-icon color="orange">mdi-close</v-icon></v-btn>
                                        </template>
                                    </confirm-modal>
                                </div>
                            </div>
                        </div>
                        <div class="form-group-horizontal" v-else-if="collection.removeAuthorPhoto">
                            <div class="horizontal-label"></div>
                            <div class="horizontal-input field-note">{{ t('collection_notice_author_photo_removed') }}</div>
                        </div>
                        <div class="form-group-horizontal-cols">
                            <div class="form-group-horizontal">
                                <div class="horizontal-label">{{ t('collection_label_level') }}</div>
                                <div class="horizontal-input">
                                    <v-select
                                        v-model="collection.level"
                                        :items="levels()"
                                        required
                                        outlined
                                        append-icon="mdi-chevron-down"
                                        dense
                                        :error-messages="form.errors.get('level')"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="form-group-horizontal">
                                <div class="horizontal-label">{{ t('collection_label_strokes') }}</div>
                                <div class="horizontal-input">
                                    <v-select
                                        v-model="collection.strokeIds"
                                        :items="strokes"
                                        item-text="name"
                                        item-value="id"
                                        required
                                        outlined
                                        append-icon="mdi-chevron-down"
                                        dense
                                        multiple
                                        :error-messages="form.errors.get('stroke_ids')"
                                    ></v-select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group-horizontal-cols">
                            <div class="form-group-horizontal">
                                <div class="horizontal-label">{{ t('collection_label_sort_order') }}</div>
                                <div class="horizontal-input">
                                    <v-text-field
                                        v-model="collection.sortOrder"
                                        type="number"
                                        step="1"
                                        required
                                        outlined
                                        dense
                                        :error-messages="form.errors.get('sort_order')"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="form-group-horizontal">
                                <div class="horizontal-label">{{ t('general_action_published') }}</div>
                                <div class="horizontal-input">
                                    <v-switch
                                        class="ma-0"
                                        v-model="collection.enabled"
                                    ></v-switch>
                                </div>
                            </div>
                        </div>

                        <div class="form-subtitle">{{ t('collection_label_audience') }}</div>
                        <div class="form-subtitle-description">{{ t('collection_hint_audience') }}</div>
                        <div
                            v-if="form.errors.consists('audience')"
                            class="red--text"
                        >{{ form.errors.get('audience') }}</div>

                        <v-simple-table class="transparent audience-table" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th style="width: 200px"></th>
                                        <th
                                            v-for="attitude in audienceAttitudes()"
                                            :key="attitude.value"
                                            class="text-center"
                                            style="width: 150px"
                                        >{{ attitude.text }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="group in audienceGroups">
                                        <tr :key="group.title" class="audience-group">
                                            <td :colspan="audienceAttitudes().length + 1">{{ t(group.title) }}</td>
                                        </tr>
                                        <tr
                                            v-for="characteristic in group.characteristics"
                                            :key="characteristic"
                                        >
                                            <td class="titled">{{ audienceCharacteristicTitle(characteristic) }}</td>
                                            <td
                                                v-for="attitude in audienceAttitudes()"
                                                :key="attitude.value"
                                                class="text-center"
                                            >
                                                <v-icon
                                                    class="touched"
                                                    :color="collection.audience[characteristic] === attitude.value ? audienceAttitudeColor(attitude.value) : 'grey lighten-1'"
                                                    @click="toggleAudience(characteristic, attitude.value)"
                                                >{{ collection.audience[characteristic] === attitude.value ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('collection_label_workouts') }}</div>
                            <div class="horizontal-input">
                                <v-btn
                                    @click="collect = true"
                                    v-ripple="false"
                                    plain
                                    color="orange darken-4"
                                    class="add"
                                >
                                    <v-icon left size="16">mdi-plus-circle</v-icon>{{ t('collection_workout_button_add') }}
                                </v-btn>
                                <span
                                    v-if="form.errors.consists('workouts')"
                                    class="red--text pl-2"
                                >{{ form.errors.get('workouts') }}</span>
                            </div>
                        </div>

                        <v-simple-table class="transparent">
                            <template v-slot:default>
                                <tbody>
                                    <tr v-if="collection.workouts.length === 0">
                                        <td class="text-center" colspan="6">{{ t('general_text_no_data') }}</td>
                                    </tr>
                                    <tr v-for="(workout, number) in collection.workouts">
                                        <td class="titled">{{ workout.id }}</td>
                                        <td class="titled">{{ workout.name }}</td>
                                        <td>{{ workout.stroke.name }}</td>
                                        <td>{{ levelTitle(workout.level) }}</td>
                                        <td>{{ time.format(workout.workoutTotalTime) }}</td>
                                        <td class="text-center">
                                            <v-menu
                                                offset-y
                                                left
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon>mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item
                                                        v-if="number > 0"
                                                        @click.prevent="moveWorkout(number, number - 1)"
                                                    >
                                                        <v-list-item-title
                                                            class="customized-primary--text"
                                                        >{{ t('general_action_move_up') }}</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item
                                                        v-if="number < collection.workouts.length - 1"
                                                        @click.prevent="moveWorkout(number, number + 1)"
                                                    >
                                                        <v-list-item-title
                                                            class="customized-primary--text"
                                                        >{{ t('general_action_move_down') }}</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item
                                                        @click.prevent="delWorkout(number)"
                                                    >
                                                        <v-list-item-title
                                                            class="orange--text"
                                                        >{{ t('general_action_delete') }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-form>
                </v-card-text>

                <v-card-actions class="px-4">
                    <v-btn
                        :to="{ name: 'workout-collections' }"
                        class="mr-4"
                        color="primary"
                    >{{ t('general_action_cancel') }}</v-btn>
                    <v-btn
                        :loading="form.busy"
                        :disabled="form.busy"
                        color="orange"
                        @click.prevent="submit"
                    >{{ collection.exists() ? t('general_action_save') : t('collection_title_create') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-layout>
    </template>
</div>
